import router from '@/router'
import { make, commit, dispatch } from 'vuex-pathify'

// API's
import Auth from '@/api/account/auth.api' 

const state = {
    token: null,
	exp: null,
	refresh: null,
}

const mutations = {
    ...make.mutations(state),

    /**
     * Reset state.
     * @param {Object} current 
     */
    reset(current) {
        Object.assign(current, state)
    }
};

const actions = {
    /**
     * User login.
     * @param {Object} context 
     * @param {Object} user 
     * @returns {Promise}
     */
    login(context, { usuario, password }) {
        return Auth.login(usuario, password)
            .then((response) => {
                commit('usuario/set', response.user)
                commit('auth/token', response.token)
                commit('auth/exp', response.exp)
                commit('auth/refresh', response.refreshToken)
                return response
            })
    },

    /**
     * User logout.
     * @param {Object} context 
     */
    logout(context) {
        dispatch('reset')
        router.push({ name: 'login' })
    },

    /**
     * Send email for forgot password.
     * @param {Object} context 
     * @param {String} usuario
     * @returns {Promise}
     */
    password_recovery(context, usuario) {
        return Auth.password_recovery(
            usuario, window.location.origin + '/password-reset'
        )
    },

    /**
     * Reset the user password.
     * @param {Object} context 
     * @param {Object} auth 
     * @returns {Promise}
     */
    password_reset(context, payload) {
        return Auth.password_reset(payload)
    },
}

const getters = {
    is_logged_in (state) {
        return !!state.token
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}